import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError(error.error.ResponseMessage);
  };

  addLetterUser(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/add-letter-user`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  editLetterUser(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/edit-letter-user`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  getLetterUserList() {
    return this.http.get(`${this.baseUrl}/messages/get-letter-user-list`)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  getMessagesList() {
    return this.http.get(`${this.baseUrl}/messages/get-all-messages`)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  getLetterUserById(id) {
    return this.http.get(`${this.baseUrl}/messages/get-letter-user-by-id/${id}`)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };


  addMessage(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/create-message`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  getUserInbox(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/user-inbox`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  getUserOutbox(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/user-outbox`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  getInboxThread(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/user-inbox-thread`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  singleDetail(id) {
    return this.http.get(`${this.baseUrl}/messages/get-single-message/${id}`)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  AddReply(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/add-reply`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  generateOtp(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/generateOtp`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  verifyOtp(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/verifyOtp`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };

  getOtpListByCreator(msgPayload) {
    return this.http.post<any>(`${this.baseUrl}/messages/getOtpListByCreator`, msgPayload)
      .pipe(map(res => {
          return res;
        }),
        catchError(MessagesService.handleError));
  };
}
